import { render, staticRenderFns } from "./CatalogMain.vue?vue&type=template&id=fb34918c&scoped=true"
import script from "./CatalogMain.vue?vue&type=script&lang=js"
export * from "./CatalogMain.vue?vue&type=script&lang=js"
import style0 from "./CatalogMain.vue?vue&type=style&index=0&id=fb34918c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb34918c",
  null
  
)

export default component.exports